import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

export default function List3({ theme, ...props }) {
  return (
    <svg
      aria-labelledby={props.ariaTags.labelledBy}
      aria-hidden={props.ariaTags.hidden}
      className={cx(theme.container, theme[props.svg], props.className)}
      shapeRendering="geometricPrecision"
      tabIndex={props.tabIndex}
      vectorEffect="non-scaling-stroke"
      viewBox="0 0 40 40"
      xmlns="http://www.w3.org/2000/svg"
    >
      {props.title ? (
        <title id={props.ariaTags.labelledBy} lang="en">
          {props.title}
        </title>
      ) : null}
      <g fill="none" fillRule="evenodd">
        <circle className={theme.fill} cx="20" cy="20" r="20" />
        <path
          className={cx(theme.numberFill, theme.secondFill)}
          d="M18.35 19.435h1.389c.66 0 1.15-.165 1.469-.496.318-.33.478-.769.478-1.316 0-.529-.158-.94-.474-1.235-.315-.294-.75-.441-1.302-.441-.499 0-.917.136-1.253.41-.337.273-.505.63-.505 1.068h-2.605c0-.685.185-1.3.554-1.844.37-.543.887-.969 1.55-1.275a5.175 5.175 0 0 1 2.196-.46c1.388 0 2.476.332 3.263.996.787.664 1.18 1.58 1.18 2.745 0 .601-.182 1.154-.549 1.659a3.572 3.572 0 0 1-1.442 1.163c.739.264 1.29.66 1.654 1.19.363.528.545 1.153.545 1.875 0 1.165-.425 2.1-1.275 2.803-.85.703-1.976 1.055-3.376 1.055-1.31 0-2.382-.346-3.214-1.037-.832-.691-1.248-1.604-1.248-2.74h2.605c0 .492.185.895.554 1.208.37.312.825.468 1.366.468.619 0 1.104-.163 1.456-.49.351-.328.527-.763.527-1.303 0-1.31-.721-1.966-2.163-1.966h-1.38v-2.037z"
        />
      </g>
    </svg>
  )
}

List3.propTypes = {
  ariaTags: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  svg: PropTypes.string.isRequired,
  theme: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  className: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
}
